/**
 * Highest to lowest. All of these pad a portrait video into a landscape frame, which is why Shorts
 * start from `oardefault` ("original aspect ratio") instead.
 */
export const YOUTUBE_THUMBNAIL_FALLBACKS = [
  'maxresdefault',
  'sddefault',
  'hqdefault',
  'mqdefault',
] as const

const YOUTUBE_ORIGINAL_ASPECT = 'oardefault'

/**
 * A missing size answers 404 with a decodable grey placeholder, so callers have to treat these
 * dimensions as a miss - the browser paints it instead of firing an error.
 */
export const YOUTUBE_PLACEHOLDER = { width: 120, height: 90 } as const

export function youtubeThumbnailChain(isShort: boolean): readonly string[] {
  return isShort
    ? [YOUTUBE_ORIGINAL_ASPECT, ...YOUTUBE_THUMBNAIL_FALLBACKS]
    : YOUTUBE_THUMBNAIL_FALLBACKS
}

export function youtubeThumbnailUrl(videoId: string, quality: string): string {
  return `https://img.youtube.com/vi/${videoId}/${quality}.jpg`
}
